// Import the functions you need from the SDKs you need
import { getApp,getApps,initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {getFirestore}from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
const firebaseConfig = {
  apiKey: "AIzaSyCnWE5Hkw7XXi_daR5LG27ZrpQzRhlJYkk",
  authDomain: "goshala-official.firebaseapp.com",
  projectId: "goshala-official",
  storageBucket: "goshala-official.firebasestorage.app",
  messagingSenderId: "297065034313",
  appId: "1:297065034313:web:f23cd2f18b90b17b7bc598",
  measurementId: "G-8FYC13J28Q"
};
// Initialize Firebase
const app = getApps.length>0 ? getApp():initializeApp(firebaseConfig);
const firestore=getFirestore(app);
const storage=getStorage(app)
const auth = getAuth(app);
const db = getFirestore(app);

export {auth,app,firestore,storage,db}